import React, {Component} from 'react';
import Navbar from "../components/base/Navbar";
import Contact from "../components/Contact";
import Footer from "../components/base/Footer";
import BlogPostsList from "../components/BlogPostsList";

class BlogPosts extends Component {
    render() {
        return (
            <div className="bg-gray-200 pt-24 bg-center">

                <Navbar/>

                <div className="w-full m-12"></div>

                <div className="my-4 text-center">
                    <h1 className="md:text-6xl font-bold drop-shadow-md bg-gradient-to-r from-blue-500 to-blue-800 inline text-transparent uppercase bg-clip-text">Blogbeiträge</h1>
                    <p className="text-gray-500 text-center font-bold">Bleib immer auf dem Laufenden!</p>
                </div>

                <div className="w-full m-12"></div>

                <div className="bg-gray-100/50 bg-border h-[5px]"></div>

                <div className="w-full m-12"></div>

                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">

                        <BlogPostsList/>

                    </div>
                </div>

                <div className="w-full m-12"></div>

                <Contact/>

                <div className="w-full m-12"></div>

                <Footer/>
            </div>
        );
    }
}

export default BlogPosts;